module.exports = __webpack_public_path__ + "img/EUDOXUS_NEW_LOGO.38f74270.png";